module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_pdv-48px"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n        Form จะรวม Class ที่ใช้สำหรับแสดงผล Input รูปแบบต่างๆ\n      ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._m(18), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n        Field เป็น Container ที่ใช้จัดการ Input Class และ Element ข้างเคียงที่ทำหน้าที่เป็น\n        Label หรือ Description ของ Input ให้แสดงผลสอดคล้องกัน\n      ")]), _vm._v(" "), _vm._m(19), _vm._v(" "), _vm._m(20), _vm._v(" "), _vm._m(21), _vm._v(" "), _vm._m(22), _vm._v(" "), _vm._m(23), _vm._v(" "), _vm._m(24), _vm._v(" "), _c('hr', {
    staticClass: "_opct-30 _mgbt-32px"
  }), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _jtfct-spbtw"
  }, [_c('div', [_c('h5', {
    staticClass: "_mgbt-16px"
  }, [_vm._v("ก่อนหน้า")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'ComponentCard'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-long-arrow-left _fs-5"
  }), _vm._v("  Card\n          ")])], 1), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-16px _tal-r"
  }, [_vm._v("ต่อไป")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'ComponentMessage'
      }
    }
  }, [_vm._v("\n            Message   "), _c('i', {
    staticClass: "fa fa-long-arrow-right _fs-5"
  })])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-2 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#component-input"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Form\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("Class ที่เกี่ยวข้อง")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-64px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-field")]), _vm._v(" "), _c('small', {
    staticClass: "_opct-60"
  }, [_vm._v("(Container) (Optional) ")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-input")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-textarea")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-select")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-checkbox")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-radio")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("Options")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-64px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class")]), _vm._v(" "), _c('th', [_vm._v("Option")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-field")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "_mgbt-32px"
  }, [_c('strong', [_vm._v("Color: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-primary")]), _vm._v(" (default),\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-accent")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-positive")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-negative")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-warning")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-info")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("State: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-disabled")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-input")])])]), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                -\n              ")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-textarea")])])]), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                -\n              ")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-select")])])]), _vm._v(" "), _c('td', [_c('p', [_c('strong', [_vm._v("Style: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-multiple")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-checkbox")])])]), _vm._v(" "), _c('td', [_c('p', [_c('strong', [_vm._v("Style: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-switch")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-radio")])])]), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                -\n              ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Input ต่างๆ แบบพื้นฐาน")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Normal Input -->\n<div class=\"bio-input\">\n  <input type=\"text\" placeholder=\"Type Something\">\n</div>\n\n<!-- Normal Textarea -->\n<div class=\"bio-textarea\">\n  <textarea rows=\"3\" placeholder=\"Textarea\"></textarea>\n</div>\n\n<!-- Normal Select -->\n<div class=\"bio-select\">\n  <select>\n    <option disabled>Please Select an Item...</option>\n    <option>Option 1</option>\n    <option>Option 2</option>\n    <option>Option 3</option>\n  </select>\n</div>\n\n<!-- Normal Checkbox -->\n<div class=\"bio-checkbox\">\n  <input id=\"c1\" type=\"checkbox\">\n  <label for=\"c1\">Checkbox</label>\n</div>\n\n<!-- Normal Radio -->\n<div class=\"bio-radio\">\n  <input id=\"r1\" type=\"radio\" name=\"radio-test1\">\n  <label for=\"r1\">Radio 1</label>\n</div>\n<div class=\"bio-radio\">\n  <input id=\"r2\" type=\"radio\" name=\"radio-test1\" checked>\n  <label for=\"r2\">Radio 2</label>\n</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "bio-input _mgbt-8px"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "placeholder": "Type Something"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bio-textarea _mgbt-8px"
  }, [_c('textarea', {
    attrs: {
      "rows": "3",
      "placeholder": "Textarea"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bio-select _mgbt-32px"
  }, [_c('select', [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Please Select an Item...")]), _vm._v(" "), _c('option', [_vm._v("Option 1")]), _vm._v(" "), _c('option', [_vm._v("Option 2")]), _vm._v(" "), _c('option', [_vm._v("Option 3")])])]), _vm._v(" "), _c('div', {
    staticClass: "bio-checkbox _mgbt-32px"
  }, [_c('input', {
    attrs: {
      "id": "c1",
      "type": "checkbox"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "c1"
    }
  }, [_vm._v("Checkbox")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-radio _mgbt-8px"
  }, [_c('input', {
    attrs: {
      "id": "r1",
      "type": "radio",
      "name": "radio-test1"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "r1"
    }
  }, [_vm._v("Radio 1")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-radio _jtfs-s _mgbt-16px"
  }, [_c('input', {
    attrs: {
      "id": "r2",
      "type": "radio",
      "name": "radio-test1",
      "checked": ""
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "r2"
    }
  }, [_vm._v("Radio 2")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-16px _fs-3"
  }, [_c('strong', [_vm._v("Switch Checkbox")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n        Checkbox สามารถใส่ Option "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-switch")]), _vm._v("\n        เพื่อเปลี่ยน Style ให้แสดงผลในลักษณะของ Switch ได้\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Switch")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<div class=\"bio-checkbox -switch\">\n  <input id=\"checkbox2\" type=\"checkbox\">\n  <label for=\"checkbox2\"></label>\n</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "bio-checkbox -switch"
  }, [_c('input', {
    attrs: {
      "id": "checkbox2",
      "type": "checkbox"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checkbox2"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-16px _fs-3"
  }, [_c('strong', [_vm._v("Multiple Select")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n        สำหรับ Select สามารถใส่ Option "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-multiple")]), _vm._v("\n        เพื่อใส่ Style ให้ Multiple Select ได้\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Multiple Select")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<div class=\"bio-select -multiple\">\n  <select multiple>\n    <option disabled>Select dropdown</option>\n    <option>Option 1</option>\n    <option>Option 2</option>\n    <option>Option 3</option>\n    <option>Option 4</option>\n  </select>\n</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "bio-select -multiple"
  }, [_c('select', {
    attrs: {
      "multiple": ""
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Select dropdown")]), _vm._v(" "), _c('option', [_vm._v("Option 1")]), _vm._v(" "), _c('option', [_vm._v("Option 2")]), _vm._v(" "), _c('option', [_vm._v("Option 3")]), _vm._v(" "), _c('option', [_vm._v("Option 4")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-16px _fs-3"
  }, [_c('strong', [_vm._v("Field")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Field – Color")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Positive -->\n<div class=\"bio-field -positive\">\n  <label><strong>Name</strong></label>\n  <div class=\"bio-input -positive\">\n    <input type=\"text\" placeholder=\"What's your name again?\" value=\"BioMaRu\">\n  </div>\n  <small>Great!, awesome name!</small>\n</div>\n\n<!-- Info -->\n<div class=\"bio-field -info\">\n  <label><strong>Optional</strong></label>\n  <div class=\"bio-select\">\n    <select>\n      <option disabled>Select dropdown</option>\n      <option>Option 1</option>\n      <option>Option 2</option>\n      <option>Option 3</option>\n    </select>\n  </div>\n  <small>You can leave this field as a blank</small>\n</div>\n\n<!-- Warinig -->\n<div class=\"bio-field -warning\">\n  <label><strong>Age</strong></label>\n  <div class=\"bio-input\">\n    <input type=\"Number\" placeholder=\"Tell me your age\">\n  </div>\n  <small>Shhhhhh!</small>\n</div>\n\n<!-- Negative -->\n<div class=\"bio-field -negative\">\n  <label><strong>Description</strong></label>\n  <div class=\"bio-textarea\">\n    <textarea rows=\"3\" placeholder=\"Tell us about you\"></textarea>\n  </div>\n  <small>Something Wrong!</small>\n</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "bio-field -positive _mgbt-16px"
  }, [_c('label', [_c('strong', [_vm._v("Name")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-input -positive"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "placeholder": "What's your name again?",
      "value": "BioMaRu"
    }
  })]), _vm._v(" "), _c('small', [_vm._v("Great!, awesome name!")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-field -info _mgbt-16px"
  }, [_c('label', [_c('strong', [_vm._v("Optional")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-select"
  }, [_c('select', [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Select dropdown")]), _vm._v(" "), _c('option', [_vm._v("Option 1")]), _vm._v(" "), _c('option', [_vm._v("Option 2")]), _vm._v(" "), _c('option', [_vm._v("Option 3")])])]), _vm._v(" "), _c('small', [_vm._v("You can leave this field as a blank")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-field -warning _mgbt-16px"
  }, [_c('label', [_c('strong', [_vm._v("Age")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-input"
  }, [_c('input', {
    attrs: {
      "type": "Number",
      "placeholder": "Tell me your age"
    }
  })]), _vm._v(" "), _c('small', [_vm._v("Shhhhhh!")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-field -negative"
  }, [_c('label', [_c('strong', [_vm._v("Description")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-textarea"
  }, [_c('textarea', {
    attrs: {
      "rows": "3",
      "placeholder": "Tell us about you"
    }
  })]), _vm._v(" "), _c('small', [_vm._v("Something Wrong!")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Field – State")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Disabled Input -->\n<div class=\"bio-field -disabled\">\n  <label><strong>Under Construction</strong></label>\n  <div class=\"bio-input\">\n    <input type=\"Number\" placeholder=\"Tell me your age\" disabled>\n  </div>\n  <small>This field is not ready yet</small>\n</div>\n\n<!-- Disabled Checkbox -->\n<div class=\"bio-field -disabled\">\n  <label><strong>Under Construction</strong></label>\n  <div class=\"bio-checkbox\">\n  <input id=\"c2\" type=\"checkbox\" disabled>\n    <label for=\"c2\">Checkbox</label>\n  </div>\n</div>\n\n<!-- Disabled Radio -->\n<div class=\"bio-field -disabled\">\n  <label><strong>Under Construction</strong></label>\n  <div class=\"bio-radio\">\n    <input id=\"r21\" type=\"radio\" name=\"r-test-2\" disabled>\n    <label for=\"r21\">Checkbox</label>\n  </div>\n  <div class=\"bio-radio\">\n    <input id=\"c22\" type=\"radio\" name=\"r-test-2\" disabled>\n    <label for=\"c22\">Checkbox</label>\n  </div>\n</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "bio-field -disabled _mgbt-32px"
  }, [_c('label', [_c('strong', [_vm._v("Under Construction")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-input"
  }, [_c('input', {
    attrs: {
      "type": "Number",
      "placeholder": "Tell me your age",
      "disabled": ""
    }
  })]), _vm._v(" "), _c('small', [_vm._v("This field is not ready yet")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-field -disabled _mgbt-16px"
  }, [_c('label', [_c('strong', [_vm._v("Under Construction")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-checkbox"
  }, [_c('input', {
    attrs: {
      "id": "c2",
      "type": "checkbox",
      "disabled": ""
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "c2"
    }
  }, [_vm._v("Checkbox")])])]), _vm._v(" "), _c('div', {
    staticClass: "bio-field -disabled _mgbt-16px"
  }, [_c('label', [_c('strong', [_vm._v("Under Construction")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-radio _mgbt-8px"
  }, [_c('input', {
    attrs: {
      "id": "r21",
      "type": "radio",
      "name": "r-test-2",
      "disabled": ""
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "r21"
    }
  }, [_vm._v("Checkbox")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-radio"
  }, [_c('input', {
    attrs: {
      "id": "c22",
      "type": "radio",
      "name": "r-test-2",
      "disabled": ""
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "c22"
    }
  }, [_vm._v("Checkbox")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-663419a3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/document-pages/ComponentForm.vue
// module id = 136
// module chunks = 0